import { Pipe, PipeTransform } from '@angular/core';
import { Link } from '../models/submissions/link';

/**
 * Looks up a presigned URL from an attachment's links.
 * - No size arg: returns the first link (matches the "main"/original file link convention already
 *   used across attachment consumers).
 * - Size arg (e.g. 'Thumb'): returns the link matching that size, or null if none exists (e.g. a
 *   non-image attachment with no thumbnail derivative).
 */
@Pipe({
  name: 'attachmentLink',
  standalone: true
})
export class AttachmentLinkPipe implements PipeTransform {
  transform(links: Link[] | null | undefined, size?: string): string | null {
    if (!links?.length) {
      return null;
    }
    if (!size) {
      return links[0]?.presignedUrl ?? null;
    }
    return links.find(link => link.size === size)?.presignedUrl ?? null;
  }
}
